import React, { useEffect, useMemo } from "react";
import { Formik } from "formik";
import { isEqual } from "lodash";
import { CustomSelect, FilterOptions, StudentSexOptions } from "../../../../../../../../_helpers/Helpers";
import { useStudentsUIContext } from "../StudentsUIContext";

const prepareFilter = (queryParams, values) => {
  let { grade, section, studentNumber, name, surname, sex } = values;
  studentNumber = studentNumber === "" ? null : studentNumber;
  const newQueryParams = { ...queryParams };
  const filter = { grade, section, studentNumber, name, surname, sex };
  newQueryParams.filter = filter;
  return newQueryParams;
};

export function StudentsFilter({
  grade  
}) {
  // Students UI Context
  const studentsUIContext = useStudentsUIContext();
  const studentsUIProps = useMemo(() => {
    return {
      setQueryParams: studentsUIContext.setQueryParams,
      queryParams: studentsUIContext.queryParams,
    };
  }, [studentsUIContext]);

  useEffect(() => {
    applyFilter({});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [grade]);

  const applyFilter = (values) => {
    values.grade = grade
    const newQueryParams = prepareFilter(studentsUIProps.queryParams, values);
    if (!isEqual(newQueryParams, studentsUIProps.queryParams)) {
      newQueryParams.pageNumber = 1;
      studentsUIProps.setQueryParams(newQueryParams);
    }
  };

  const sexOptions = FilterOptions.concat(StudentSexOptions);

  return (
    <Formik
      initialValues={{
        section: "",
        studentNumber: "",
        name: "",
        surname: ""
      }}
      onSubmit={(values) => {
        if (grade) applyFilter(values);
      }}
    >
      {({
        values,
        handleSubmit,
        handleBlur,
        setFieldValue,
      }) => (
        <form onSubmit={handleSubmit} className="form form-label-right">
          <div className="form-group row">
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="section"
                placeholder="Şube"
                onBlur={handleBlur}
                value={values.section}
                onChange={(e) => {
                  setFieldValue("section", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Şube</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="studentNumber"
                placeholder="Öğrenci Numarası"
                onBlur={handleBlur}
                value={values.studentNumber}
                onChange={(e) => {
                  setFieldValue("studentNumber", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Öğrenci Numarası</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="name"
                placeholder="Adı"
                onBlur={handleBlur}
                value={values.name}
                onChange={(e) => {
                  setFieldValue("name", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Adı</b>
              </small>
            </div>
            <div className="col-lg-2">
              <input
                type="text"
                className="form-control"
                name="surname"
                placeholder="Soyadı"
                onBlur={handleBlur}
                value={values.surname}
                onChange={(e) => {
                  setFieldValue("surname", e.target.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Soyadı</b>
              </small>
            </div>
            <div className="col-lg-2">
              <CustomSelect 
                options={sexOptions}
                value={values.sex}
                placeholder="Cinsiyeti"
                onBlur={handleBlur}
                onChange={e => {
                  setFieldValue("sex", e.value);
                  handleSubmit();
                }}
              />
              <small className="form-text text-muted">
                <b>Cinsiyeti</b>
              </small>
            </div>
          </div>
        </form>
      )}
    </Formik>
  );
}